<template>
    <!-- ------------------------------------- 博客 ----------------------------------- -->
    <div class="blog">
        <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
        <Header></Header>
        <!-- ---------------------------------- 海报图 ---------------------------------- -->
        <!-- ---------------------------------- 文章 ---------------------------------- -->
        <div class="article">
            <!-- 主文章 -->
            <div class="article_main">
                <!-- 文章标题 -->
                <h2 class="article_title">条款细则</h2>
                <!-- 文章信息 -->
                <div class="article_information">
                    <p>
                        使用本网站前，请仔细阅读以下使用条款。本网站的所有用户同意，访问和使用本网站受以下条款和条件以及其他适用法律的约束。如果您不同意这些条款和条件，请不要使用本网站。
                    </p>
                    <h3 class="title">版权</h3>
                    <p>
                        本网站所包含的全部内容，包括但不限于文字、图形或代码，作为版权法下的集体作品受版权保护，是Renaud蔚诺的财产。集体作品包括许可给Renaud蔚诺的作品。允许以电子方式复制和打印本网站的硬拷贝部分，仅用于向Renaud蔚诺下订单或购买Renaud蔚诺的产品。您可以在明确规定的与特定材料相关的限制或限制条件下，从本网站的不同区域下载或打印部分材料，仅用于您自己的非商业用途，或向Renaud蔚诺下订单或购买Renaud蔚诺的产品。除非Renaud蔚诺授权，否则严禁任何其他用途，包括但不限于复制、分发、展示或传播本网站的内容。您进一步同意不更改或删除从本网站下载的资料中的任何专有通知。
                    </p>
                    <h3 class="title">商标</h3>
                    <p>
                        现场使用的Renaud蔚诺的所有商标、服务商标和商号均为Renaud蔚诺的商标或注册商标。
                    </p>
                    <h3 class="title">免责声明</h3>
                    <p>
                        本网站及本网站上的材料和产品均按“原样”提供，无任何明示或暗示的保证，除非在说明中另有说明。在适用法律允许的最大范围内，Renaud蔚诺放弃所有明示或暗示的保证，包括但不限于对适销性和特定用途适用性以及非侵权性的暗示保证。Renaud蔚诺不声明或保证本网站包含的功能不会中断或无错误，缺陷将得到纠正，或者本网站或提供本网站的服务器没有病毒或其他有害组件。Renaud蔚诺不就本网站材料的正确性、准确性、充分性、有用性、及时性、可靠性或其他方面的使用作出任何保证或陈述。有些国家不允许对保修进行限制或排除，因此上述限制可能不适用于您。
                    </p>
                    <h3 class="title">责任限制</h3>
                    <p>
                        Renaud蔚诺对因使用或无法使用本现场材料或产品性能而造成的任何特殊或后果性损害不承担任何责任，即使Renaud蔚诺已被告知此类损害的可能性。适用法律可能不允许免除责任或附带或后果性损害的限制，因此上述限制或排除可能不适用于您。
                    </p>
                    <h3 class="title">印刷错误</h3>
                    <p>
                        如果Renaud蔚诺的产品错误地以错误的价格上市，Renaud蔚诺保留拒绝或取消以错误价格上市的产品的任何订单的权利。Renaud蔚诺保留拒绝或取消任何此类订单的权利，无论订单是否已确认以及您的信用卡是否已被收取费用。如果您的信用卡已被收取购买费用，并且您的订单被取消，Renaud蔚诺将向您的信用卡账户发放金额不正确的信用卡。
                    </p>
                    <h3 class="title">期限；终止</h3>
                    <p>
                        这些条款和条件适用于您访问网站和/或完成注册或购物过程。Renaud蔚诺可随时以任何理由终止本条款和条件或其任何部分，无需另行通知。与版权、商标、免责声明、责任限制、赔偿和其他相关的规定应在任何终止后继续有效。
                    </p>
                    <h3 class="title">通知</h3>
                    <p>
                        Renaud蔚诺可通过电子邮件、网站上的一般通知或其他可靠方式向您发送通知至您提供给Renaud蔚诺的地址。
                    </p>

                    <h3 class="title">网站使用</h3>
                    <p>
                        严禁在网站上以任何方式或形式进行骚扰，包括通过电子邮件、聊天或使用淫秽或辱骂性语言。禁止在网站上冒充他人，包括Renaud蔚诺或其他持照员工、主持人或代表，以及其他成员或访客。您不得上传、分发或通过本网站发布任何诽谤、诽谤、淫秽、威胁、侵犯隐私权或宣传权、滥用、非法或其他可能构成或鼓励刑事犯罪的令人反感的内容，侵犯任何一方的权利或可能导致责任或违反任何法律。您不得在本网站上传商业内容，也不得利用本网站招揽他人加入或成为任何其他商业在线服务或其他组织的成员。
                    </p>
                    <h3 class="title">参与免责声明</h3>
                    <p>
                        Renaud蔚诺不也不能审查所有张贴到或由访问网站的用户创建的通信和材料，也不以任何方式对这些通信和材料的内容负责。您承认，通过向您提供在现场查看和分发用户生成内容的能力，Renaud蔚诺只是作为此类分发的被动渠道，不承担任何与现场任何内容或活动相关的义务或责任。然而，Renaud蔚诺保留阻止或删除其认定为（a）滥用、诽谤或淫秽的通信或材料的权利，（b）欺诈、欺骗或误导，（c）违反版权、商标或；另一方或（d）侵犯或其他不可接受的知识产权，由Renaud蔚诺自行决定。
                    </p>

                    <h3 class="title">赔偿</h3>
                    <p>
                        您同意赔偿、保护Renaud蔚诺、其高级职员、董事、雇员、代理人、许可人和供应商（统称为“服务提供商”）免受所有损失、费用、损害和成本，包括合理的律师费，由于您或任何其他人使用您的Internet帐户访问网站时违反本条款和条件或与您的帐户相关的任何活动（包括疏忽或不法行为）。
                    </p>
                    <h3 class="title">第三方链接</h3>
                    <p>
                        为了向我们的游客提供更高的价值，Renaud蔚诺可以链接到第三方运营的网站。然而，即使第三方隶属于Renaud蔚诺，Renaud蔚诺也无法控制这些链接网站，所有这些网站都有独立的隐私和数据收集做法，独立于Renaud蔚诺。这些链接站点只为您的方便，因此您可以自行访问它们。尽管如此，Renaud蔚诺力求保护其网站的完整性和链接，因此不仅要求对其自己的网站，而且也要求对其链接的网站（包括如果某个特定链接不起作用）提供任何反馈。
                    </p>
                </div>
            </div>
            <!-- 副文章 -->
        </div>
        <!-- ---------------------------------- 分页栏 ---------------------------------- -->
        <!-- <div class="paging">
            <el-pagination
                    background
                    layout=" pager, next"
                    :total="50">
            </el-pagination>
        </div> -->
        <!-- ---------------------------------- 底部栏 ---------------------------------- -->
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
export default {
    components: {
        Header,
        Footer,
    },
    methods: {
        // 跳转文章详情
        toBlogDetails() {
            this.$router.push({
                path: '/blogDetails',
            });
        },
    },
};
</script>

<style lang="less" scoped>
// ---------------------------- 细则 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    .article {
        // 主文章
        .article_main {
            width: 85%;
            // 文章标题
            .article_title {
                font-size: 62px;
            }
            // 文章信息
            .article_information {
                .title {
                    font-size: 56px;
                    margin: 20px 0 0 0;
                }
                p {
                    font-size: 50px;
                    margin: 20px 0;
                }
            }
        }
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    .article {
        // 主文章
        .article_main {
            width: 55%;
            // 文章标题
            .article_title {
                font-size: 38px;
            }
            // 文章信息
            .article_information {
                .title {
                    font-size: 19px;
                    margin: 10px 0 0 0;
                }
                p {
                    font-size: 16px;
                    margin: 0;
                }
            }
        }
    }
}

.article {
    width: 100%;
    margin: 0 auto;
    padding: 80px 0 60px 0;
    display: flex;
    justify-content: space-between;
    font-family: '等线';
    // 主文章
    .article_main {
        margin: 0 auto;
        // 文章标题
        .article_title {
            font-weight: 600;
            color: #192c54;
            letter-spacing: 2px;
            margin: 0;
            cursor: pointer;
        }
        // 文章信息
        .article_information {
            font-family: Microsoft YaHei;
            width: 100%;
            .title {
                font-family: Microsoft YaHei;
                font-weight: bold;
            }
            p {
                font-family: Microsoft YaHei;
                color: #000;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/clause.vue